import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { IChatBotV2RespuestaAceptacionTYC } from '../../../models/chat-bot-v2.model';
import { LoadingService } from '../../../services';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../services/chat-bot-v2/chat-bot-v2.service';
import { FeatureVarsService } from '../../../services/feature-vars/feature-vars.service';
import { LayoutService } from '../../../services/layout/layout.service';
import { ChatBotAsesorV2EncuestaComponent } from '../chat-bot-asesor-v2-encuesta/chat-bot-asesor-v2-encuesta.component';
import { ChatBotAsesorV2TerminosComponent } from '../chat-bot-asesor-v2-terminos/chat-bot-asesor-v2-terminos.component';
import { ChatBotAsesorV2Component } from '../chat-bot-asesor-v2.component';

@Component({
  selector: 'app-chat-bot-asesor-v2-btn',
  templateUrl: './chat-bot-asesor-v2-btn.component.html',
})
export class ChatBotAsesorV2BtnComponent {

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    private dialog: MatDialog,
    private chatBotV2S: ChatBotV2Service,
    private loadingService: LoadingService,
    private featureVarsS: FeatureVarsService,
    private layoutS: LayoutService
  ) { }

  public async openChat() {
    this.chatBotV2DS.tabActive.next(0);
    const aceptacion = await this.obtenerAceptacion();
    if (!aceptacion) return;
    const dialogRef = this.dialog.open(ChatBotAsesorV2Component, {
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      panelClass: 'dialog-fullscreen',
    });
    dialogRef.beforeClosed().pipe(
      tap((data) => {
        if (data?.sinFeedback || !this.chatBotV2DS.sessionID) return;
        this.dialogEncuesta();
        this.chatBotV2DS.eliminarChat();
      }),
      tap(() => this.layoutS.forceResizeSub.next()),
    ).subscribe();
  }

  private async setConfigVars() {
    try {
      const config = await this.featureVarsS.get('CHATBOT_ASESOR_V2_CONFIG');
      this.chatBotV2DS.configVars = config;
      this.chatBotV2DS.sePuedeSubirDocumentos = config?.HABILITAR_SUBIDA_DOCUMENTOS_CHATBOT_V2?.estado === 'ACTIVO';
    } catch (error) {
      console.log('NO ES POSIBLE CARGAR LAS CONFIGURACIONES DEL CHATBOT, ' + error?.message);
    }
  }

  private async obtenerAceptacion() {
    this.loadingService.showLoading();
    await this.setConfigVars();
    const aceptacion: IChatBotV2RespuestaAceptacionTYC = await this.chatBotV2S.obtenerAceptacionTYC();
    this.loadingService.hideLoading();
    if (aceptacion.response && aceptacion.data && aceptacion.data.acepta) return true;
    const dialogRef = this.dialog.open(ChatBotAsesorV2TerminosComponent, {
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      maxWidth: '600px',
      panelClass: 'sura'
    });
    return dialogRef.afterClosed().toPromise();
  }

  private async dialogEncuesta() {
    const dialogRef = this.dialog.open(ChatBotAsesorV2EncuestaComponent, {
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      maxWidth: '600px',
      panelClass: 'sura'
    });
    return dialogRef.afterClosed().toPromise();
  }


}
